import { render, staticRenderFns } from "./EntregaProdutosComprasItemContent.vue?vue&type=template&id=78acf74e"
import script from "./EntregaProdutosComprasItemContent.vue?vue&type=script&lang=js"
export * from "./EntregaProdutosComprasItemContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports